import React from 'react';
import { ListLabels } from './listTypes';
import QuestionList from './questionList';

const ArchivedQuestionsList: React.FC = () => {
  return (
    <>
      <QuestionList listType={ListLabels.archivedQuestions} />
    </>
  );
};

export default ArchivedQuestionsList;
